<div class="app-container">
  <ng-content></ng-content>
</div>
